function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { ConfirmationModal } from "../ConfirmationModal";
import { useOverlayContext } from "../OverlayContext";
import { jsx as _jsx } from "react/jsx-runtime";
export function UnsavedChangesModal(props) {
  const {
    testId,
    title = 'Unsaved changes',
    primaryButtonLabel = 'Discard changes',
    primaryButtonTestId,
    secondaryButtonTestId,
    content = 'You have unsaved changes that will be lost if you leave this page',
    dismissModal
  } = props;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    testId: testId,
    skin: "danger",
    title: title,
    content: content,
    primaryButtonLabel: primaryButtonLabel,
    secondaryButtonLabel: "Keep editing",
    primaryButtonTestId: primaryButtonTestId,
    secondaryButtonTestId: secondaryButtonTestId,
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}
export function useOpenUnsavedChangesModal() {
  const globalContext = useOverlayContext();
  return function openUnsavedChangesModal(props) {
    return globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(UnsavedChangesModal, _objectSpread(_objectSpread({}, props), {}, {
          dismissModal: dismissModal
        }));
      }
    });
  };
}